import { useCurrentCompany, useCurrentUser } from '../hooks';
import { getCurrentCompany, getCurrentUser, Permission } from '../lib';
import { PermissionValidations } from '../lib/handlers/permission-validations';

export function usePermission(permissions?: Permission | Permission[]): boolean {
	const company = useCurrentCompany();
	const user = useCurrentUser();
	// no permissions given
	if (!permissions || !permissions.length) return false;

	const list = Array.isArray(permissions) ? permissions : [permissions];
	const isAllowed = list.every((permission) => {
		const fn = PermissionValidations[permission];
		if (!fn) {
			console.warn('who-am-i:use-permission Validation for permission not found', permission);
			return false;
		}
		return fn({ company, user });
	});

	return isAllowed;
}

// This is for async permission checks outside of the React lifecycle
export const getPermission = async (permission: Permission) => {
	const user = await getCurrentUser();
	const company = await getCurrentCompany();
	return PermissionValidations[permission]({ company, user });
};
